module.exports = __webpack_public_path__ + "static/media/flag1-red.a22d4484.svg";